// extracted by mini-css-extract-plugin
module.exports = {"banner":"Press_banner__6vnUq","btn":"Press_btn__jgckb","itemsOnImg":"Press_itemsOnImg__1rYvm"};